__webpack_require__.p = "/ma/ar/customer-service/returns-claims/spareparts/";